import React from 'react'
import clientsJson from '../data/clients.json'

import './styles/ClientsList.scss'
import {v4 as uuidv4} from 'uuid'

// Swiper
import {Swiper, SwiperSlide} from 'swiper/react'
import {Autoplay} from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/bundle'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'

// Импортируем все картинки из папки
const images = require.context('../images/client-logos', false, /\.(png|jpe?g|svg)$/)

// Ручной список клиентов (name)
const visibleClients = [
    'kommunai',
    'adaoil',
    'ssmoil',
    'petroleum',
    'kazturkmunaigas',
    'rg',
    'arx',
    'zarechnoe',
    'rusburmash',
    'spk',
    'esteeLauder',
    'oriflame',
    'marykay',
    'santo',
    'homecredit',
    'mlombard',
    'seifcar',
    'seiflombard',
    'allur',
    'shymkentpivo',
    'samolet',
]

const ClientsList = () => {
    const filteredClients = clientsJson.filter(
        (client) =>
            visibleClients.includes(client.name) &&
            images.keys().includes(`./${client.name}.png`)
    )

    return (
        <div className="our-clients">
            <a href={'/clients'}>Перейти ко всем клиентам</a>

            <div className="clients-list">
                <Swiper
                    spaceBetween={30}
                    slidesPerView={2}
                    className="swiper-clients-list"
                    modules={[Autoplay]}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    loop={true}
                    breakpoints={{
                        700: {
                            slidesPerView: 5,
                        }
                    }}
                >
                    {filteredClients.map((client) => (
                        <SwiperSlide key={uuidv4()}>
                            <a
                                href={`/clients/${client.name}`}
                                className="swiper-clients-list__item"
                                style={{
                                    backgroundImage: `url(${images(`./${client.name}.png`)})`,
                                }}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            <p className="main-text main-text--thin main-text--sm">
                За 11 лет мы успели поработать со множеством компаний
            </p>
        </div>
    )
}

export default ClientsList
